import { EventEmitter } from "@angular/core";
import { Address } from "@app/address/model/address";
import { Customer } from "@app/customer/model/customer";
import { Entity } from "@app/entity/model/entity";
import { EntityWithAncestors } from "@app/entity/services/entity-db.service";
import { CentralStationProject } from "@app/project/model/central-station-project";
import { ClareSystem } from "@app/project/model/clare-system";
import { PanelSummary } from "@app/project/model/panel-summary";
import { Project } from "@app/project/model/project";
import { ProjectListItemData } from "@app/project/model/project-list-item";
import { ProjectView } from "@app/project/model/project-view";
import { SecuritySystem } from "@app/project/model/security-system";
import { createNoPropsAction } from "@app/root-store/actions/action-creators";
import { ClareStatus } from "@app/shared/model/clare-status.model";
import { User } from "@app/user/model/user";
import { Action } from "@ngrx/store";
import { BehaviorSubject } from "rxjs";
import { DataAction, DataErrorAction } from "../../../shared/resources/data-actions";
import { DataServiceError } from "../../../shared/services/data-service-error";
import { ConfirmationAction } from "./generic.action";

export enum ActionTypes {
    CreateProject = "[Project Management] CreateProject",
    CreateProjectNoCustomer = "[Project Management] CreateProjectNoCustomer",
    CreateProjectController = "[Project Management] CreateProjectController",
    CreateProjectControllerFailure = "[Project Management] CreateProjectControllerFailure",
    CreateProjectSuccess = "[Project Management] CreateProjectSuccess",
    CreateProjectFailure = "[Project Management] CreateProjectFailure",
    GetProject = "[Project Management] GetProject",
    GetProjectSuccess = "[Project Management] GetProjectSuccess",
    GetProjectFailure = "[Project Management] GetProjectFailure",
    ClearActiveProject = "[Project Management] ClearActiveProject",
    ClearActiveProjectEntity = "[Project Management] ClearActiveProjectEntity",
    ClearActiveProjectStatus = "[Project Management] ClearActiveProjectStatus",
    GetActiveProject = "[Project Management] GetActiveProject",
    GetActiveProjectSuccess = "[Project Management] GetActiveProjectSuccess",
    GetActiveProjectFailure = "[Project Management] GetActiveProjectFailure",
    GetActiveProjectStatus = "[Project Management] GetActiveProjectStatus",
    GetActiveProjectStatusSuccess = "[Project Management] GetActiveProjectStatusSuccess",
    GetActiveProjectStatusFailure = "[Project Management] GetActiveProjectStatusFailure",
    GetProjects = "[Project Management] GetProjects",
    ClearProjects = "[Project Management] ClearProjects",
    GetProjectsSuccess = "[Project Management] GetProjectsSuccess",
    GetProjectsFailure = "[Project Management] GetProjectsFailure",
    GetProjectsUUIDs = "[Project Management] GetProjectsUUIDs",
    GetProjectsUUIDsSuccess = "[Project Management] GetProjectsUUIDsSuccess",
    GetProjectsUUIDsFailure = "[Project Management] GetProjectsUUIDsFailure",
    GetProjectsUUIDsSummary = "[Project Management] GetProjectsUUIDsSummary",
    GetProjectsUUIDsSummarySuccess = "[Project Management] GetProjectsUUIDsSummarySuccess",
    GetProjectsUUIDsSummaryFailure = "[Project Management] GetProjectsUUIDsSummaryFailure",
    GetProjectUsers = "[Project Management] GetProjectUsers",
    GetProjectUsersSuccess = "[Project Management] GetProjectsUsersSuccess",
    GetProjectUsersFailure = "[Project Management] GetProjectsUsersFailure",
    ClearCentralStationProjectData = "[Project Management] ClearCentralStationProjectData",
    GetCentralStationProjectData = "[Project Management] GetCentralStationProjectData",
    GetCentralStationProjectDataSuccess = "[Project Management] GetCentralStationProjectDataSuccess",
    GetCentralStationProjectDataFailure = "[Project Management] GetCentralStationProjectDataFailure",
    GetActiveProjectEntity = "[Project Management] GetProjectEntity",
    GetActiveProjectEntitySuccess = "[Project Management] GetProjectEntitySuccess",
    GetActiveProjectEntityFailure = "[Project Management] GetProjectEntityFailure",
    GetSelectedEntity = "[Project Management] GetSelectedEntity",
    GetSelectedEntitySuccess = "[Project Management] GetSelectedEntitySuccess",
    GetSelectedEntityFailure = "[Project Management] GetSelectedEntityFailure",
    SetSelectedEntity = "[Project Management] SetSelectedEntity",
    SetSelectedEntitySuccess = "[Project Management] SetSelectedEntitySuccess",
    SetSelectedEntityFailure = "[Project Management] SetSelectedEntityFailure",
    UpdateProject = "[Project Management] UpdateProject",
    UpdateProjectSuccess = "[Project Management] UpdateProjectSuccess",
    UpdateProjectFailure = "[Project Management] UpdateProjectFailure",
    UpdateProjectDealer = "[Project Management] UpdateProjectDealer",
    UpdateProjectDealerSuccess = "[Project Management] UpdateProjectDealerSuccess",
    UpdateProjectDealerFailure = "[Project Management] UpdateProjectDealerFailure",
    GoToProjects = "[Project Management] GoToProjects",
    ProcessProject = "[Project Management] ProcessProject",
    UpdateProjectController = "[Project Management] UpdateProjectController",
    UpdateProjectControllerSuccess = "[Project Management] UpdateProjectControllerSuccess",
    CreateProjectUser = "[ProjectManagement] CreateProjectUser",
    CreateProjectUserSuccess = "[ProjectManagement] CreateProjectUserSuccess",
    CreateProjectUserFailure = "[ProjectManagement] CreateProjectUserFailure",
    UpdateProjectUser = "[ProjectManagement] UpdateProjectUser",
    UpdateProjectUserSuccess = "[ProjectManagement] UpdateProjectUserSuccess",
    UpdateProjectUserFailure = "[ProjectManagement] UpdateProjectUserFailure",
    DeleteProjectUser = "[ProjectManagement] DeleteProjectUser",
    DeleteProjectUserConfirmation = "[ProjectManagement] DeleteProjectUserConfirmation",
    DeleteProjectUserConfirmationDismiss = "[ProjectManagement] DeleteProjectUserConfirmationDismiss",
    DeleteProjectUserSuccess = "[ProjectManagement] DeleteProjectUserSuccess",
    DeleteProjectUserFailure = "[ProjectManagement] DeleteProjectUserFailure",
    DeleteProject = "[Project Management] DeleteProject",
    DeleteProjectConfirmation = "[Project Management] DeleteProjectConfirmation",
    DeleteProjectConfirmationDismiss = "[Project Management] DeleteProjectConfirmationDismiss",
    DeleteProjectSuccess = "[Project Management] DeleteProjectSuccess",
    DeleteProjectFailure = "[Project Management] DeleteProjectFailure",
    UpsertSecuritySystem = "[Project Management] UpsertSecuritySystem",
    ClearProjectState = "[Project Management ] ClearProjectState",
    ClearProjectStatuses = "[Project Management] Clear Online Statuses",
    UpdateProjectStatuses = "[Project Management] Update Online Statuses",
    UpdateProjectStatusesSuccess = "[Project Management] Update Online Statuses Success",
    UpdateProjectStatusesFailure = "[Project Management] Update Online Statuses Failure",
    ActiveOrSuspendProject = "[Project Management] Active Or Suspend Project",
    ActiveOrSuspendProjectSuccess = "[Project Management] Active Or Suspend Project Success",
    ActiveOrSuspendProjectFailure = "[Project Management] Active Or Suspend Project Failure",
    SaveEmergencyContact = "[Project Management] Create Project Emergency Contact",
    CreateEmergencyContactSuccess = "[Project Management] Create Project Emergency Contact Success",
    CreateEmergencyContactFailure = "[Project Management] Create Project Emergency Contact Failure",
    RemoveContactConfirmation = "[Project Management] Remove Contact Confirmation",
    RemoveContactConfirmationDismiss = "[Project Management] Remove Contact Confirmation Dismiss",
    UpdateEmergencyContacts = "[Project Management] Update Emergency Contacts",
    UpdateEmergencyContactsSuccess = "[Project Management] Update Emergency Contacts Success",
    UpdateEmergencyContactsFailure = "[Project Management] Update Emergency Contacts Failure",
    RemoveEmergencyContact = "[Project Management] Remove Emergency Contact",
    RemoveEmergencyContactSuccess = "[Project Management] Remove Emergency Contact Success",
    RemoveEmergencyContactFailure = "[Project Management] Remove Emergency Contact Failure",
    UpdateMunicipality = "[Project Management] Update Municipality",
    UpdateMunicipalitySuccess = "[Project Management] Update Municipality Success",
    UpdateMunicipalityFailure = "[Project Management] Update Municipality Failure",
    GetActiveProjectByUuid = "[Project Management] Get Active Project By Uuid",
    MoveOutSuccess = "[Project Management] Move Out Success",
    GetActivePanelSummary = "[Project Management] Get Active Panel Summary",
    GetActivePanelSummarySuccess = "[Project Management] Get Active Panel Summary Success",
    GetActivePanelSummaryFailure = "[Project Management] Get Active Panel Summary Failure",
    ClearActivePanelSummary = "[Project Management] Clear Active Panel Summary",
}
const category = "Project";
export const setProjectListEntity = createNoPropsAction(category, "Set Local Storage");

export abstract class ProjectAction implements DataAction<Project> {
    readonly type: string;
    constructor(
        public readonly payload: Project,
        public readonly closeDialog?: EventEmitter<Action>,
        public readonly confirmation?: ConfirmationAction
    ) {}
}

export class ProjectSuccessAction extends ProjectAction {}

export abstract class ProjectFailureAction implements DataErrorAction<Project> {
    public readonly type: string;
    constructor(public readonly error: DataServiceError<Project>) {}
}

export class CreateProject implements Action {
    readonly type = ActionTypes.CreateProject;

    constructor(
        public payload: {
            project$: BehaviorSubject<Project>;
            customer: User;
            address: Address;
            customerCreatedEmitter?: EventEmitter<any>;
        }
    ) {}
}

export class CreateProjectNoCustomer implements Action {
    readonly type = ActionTypes.CreateProjectNoCustomer;

    constructor(
        public payload: {
            project$: BehaviorSubject<Project>;
            address: Address;
            entityId: number;
        }
    ) {}
}

export class CreateProjectController implements Action {
    readonly type = ActionTypes.CreateProjectController;

    constructor(
        public claresystem: ClareSystem,
        public project: Project,
        public securitysystem: SecuritySystem,
        public closeDialog?: any,
        public customer?: Customer,
        public entity?: Entity,
        public isNewProject = false,
        public address?: Address
    ) {}
}

export class CreateProjectUser implements Action {
    readonly type = ActionTypes.CreateProjectUser;

    constructor(
        public payload: {
            userData: any;
            project: Project;
            userInfoKey: string;
        },
        public closeDialog?: EventEmitter<any>
    ) {}
}

export class CreateProjectUserSuccess extends ProjectSuccessAction {
    readonly type = ActionTypes.CreateProjectUserSuccess;
}

export class CreateProjectUserFailure implements Action {
    readonly type = ActionTypes.CreateProjectUserFailure;

    constructor(public error: DataServiceError<Project>) {}
}

export class UpdateProjectUser implements Action {
    readonly type = ActionTypes.UpdateProjectUser;

    constructor(public payload: { userData: any; project: Project }, public closeDialog?: EventEmitter<void>) {}
}

export class UpdateProjectUserSuccess extends ProjectSuccessAction {
    readonly type = ActionTypes.UpdateProjectUserSuccess;
}

export class UpdateProjectUserFailure extends ProjectFailureAction {
    readonly type = ActionTypes.UpdateProjectUserFailure;
}

export class DeleteProjectUser implements Action {
    readonly type = ActionTypes.DeleteProjectUser;

    constructor(
        public payload: {
            userData: any;
            project: Project;
            userInfoKey: string;
        },
        public closeDialog?: EventEmitter<Project>
    ) {}
}

export class DeleteProjectUserConfirmation implements Action {
    readonly type = ActionTypes.DeleteProjectUserConfirmation;

    constructor(
        public payload: {
            userData: any;
            project: Project;
            userInfoKey: string;
        },
        public closeDialog?: EventEmitter<Project>
    ) {}
}

export class DeleteProjectUserConfirmationDismiss implements Action {
    readonly type = ActionTypes.DeleteProjectUserConfirmationDismiss;
}

export class DeleteProjectUserSuccess extends ProjectSuccessAction {
    readonly type = ActionTypes.DeleteProjectUserSuccess;
}

export class DeleteProjectUserFailure extends ProjectFailureAction {
    readonly type = ActionTypes.DeleteProjectUserFailure;
}

export class UpdateProjectControllerSuccess extends ProjectSuccessAction {
    readonly type = ActionTypes.UpdateProjectControllerSuccess;
}

export class CreateProjectControllerFailure extends ProjectFailureAction {
    readonly type = ActionTypes.CreateProjectControllerFailure;
}

export class CreateProjectSuccess extends ProjectSuccessAction {
    readonly type = ActionTypes.CreateProjectSuccess;
}

export class CreateProjectFailure implements Action {
    readonly type = ActionTypes.CreateProjectFailure;

    constructor(public error: DataServiceError<Project>) {}
}

export class GetProject implements Action {
    readonly type = ActionTypes.GetProject;

    constructor(public payload: number) {}
}

export class GetProjectSuccess implements Action {
    readonly type = ActionTypes.GetProjectSuccess;

    constructor(public payload: any) {}
}

export class GetProjectFailure implements Action {
    readonly type = ActionTypes.GetProjectFailure;

    constructor(public error: DataServiceError<Project>) {}
}

export class GetActiveProjectEntity implements Action {
    readonly type = ActionTypes.GetActiveProjectEntity;

    constructor(public payload: number) {}
}

export class GetActiveProjectEntitySuccess implements Action {
    readonly type = ActionTypes.GetActiveProjectEntitySuccess;

    constructor(public result: EntityWithAncestors) {}
}

export class GetActiveProjectEntityFailure implements Action {
    readonly type = ActionTypes.GetActiveProjectEntityFailure;

    constructor(public error: DataServiceError<EntityWithAncestors>) {}
}

export class SetSelectedEntity implements Action {
    readonly type = ActionTypes.SetSelectedEntity;

    constructor(public payload: number) {}
}

export class SetSelectedEntitySuccess implements Action {
    readonly type = ActionTypes.SetSelectedEntitySuccess;

    constructor(public result: number) {}
}

export class ClearActiveProject implements Action {
    readonly type = ActionTypes.ClearActiveProject;
}

export class ClearActiveProjectEntity implements Action {
    readonly type = ActionTypes.ClearActiveProjectEntity;
}

export class ClearActiveProjectStatus implements Action {
    readonly type = ActionTypes.ClearActiveProjectStatus;
}

export class GetActiveProject implements Action {
    readonly type = ActionTypes.GetActiveProject;

    constructor(public payload: number) {}
}

export class GetActiveProjectByUuid implements Action {
    readonly type = ActionTypes.GetActiveProjectByUuid;
    // payload: uuid
    constructor(public payload: string) {}
}

export class GetActiveProjectSuccess implements Action {
    readonly type = ActionTypes.GetActiveProjectSuccess;

    constructor(public result: Project) {}
}

export class GetActiveProjectFailure implements Action {
    readonly type = ActionTypes.GetActiveProjectFailure;

    constructor(public error: DataServiceError<Project>) {}
}

export class GetActiveProjectStatus implements Action {
    readonly type = ActionTypes.GetActiveProjectStatus;

    constructor(public payload: { uuid: string }) {}
}

export class GetActiveProjectStatusSuccess implements Action {
    readonly type = ActionTypes.GetActiveProjectStatusSuccess;

    constructor(public result: ClareStatus) {}
}

export class GetActiveProjectStatusFailure implements Action {
    readonly type = ActionTypes.GetActiveProjectStatusFailure;

    constructor(public error: DataServiceError<ClareStatus>) {}
}

export class GetProjects implements Action {
    readonly type = ActionTypes.GetProjects;

    constructor(public payload: { entityId: number; projectView?: ProjectView }) {}
}

export class ClearProjects implements Action {
    readonly type = ActionTypes.ClearProjects;
}

export class GetProjectsSuccess implements Action {
    readonly type = ActionTypes.GetProjectsSuccess;

    constructor(
        public payload: {
            projects: ProjectListItemData[];
        }
    ) {}
}

export class GetProjectsFailure implements Action {
    readonly type = ActionTypes.GetProjectsFailure;

    constructor(public error: DataServiceError<Project>) {}
}

export class GetProjectsUUIDs implements Action {
    readonly type = ActionTypes.GetProjectsUUIDs;

    constructor(public payload: number) {}
}

export class GetProjectsUUIDsSuccess implements Action {
    readonly type = ActionTypes.GetProjectsUUIDsSuccess;

    constructor(
        public payload: {
            project_id: number;
            uuid: string;
        }[]
    ) {}
}

export class GetProjectsUUIDsFailure implements Action {
    readonly type = ActionTypes.GetProjectsUUIDsFailure;

    constructor(public error: DataServiceError<Project>) {}
}

export class GetProjectUsers implements Action {
    readonly type = ActionTypes.GetProjectUsers;

    constructor(public payload: number) {}
}

export class GetProjectUsersSuccess implements Action {
    readonly type = ActionTypes.GetProjectUsersSuccess;

    constructor(
        public payload: {
            projectId: number;
            users: any;
        }
    ) {}
}

export class GetProjectUsersFailure implements Action {
    readonly type = ActionTypes.GetProjectUsersFailure;

    constructor(public error: DataServiceError<Project>) {}
}

export class ClearCentralStationProjectData implements Action {
    readonly type = ActionTypes.ClearCentralStationProjectData;
}

export class GetCentralStationProjectData implements Action {
    readonly type = ActionTypes.GetCentralStationProjectData;

    constructor(public payload: string[]) {}
}

export class GetCentralStationProjectDataSuccess implements Action {
    readonly type = ActionTypes.GetCentralStationProjectDataSuccess;

    constructor(
        public payload: {
            centralStationProjects: CentralStationProject[];
        }
    ) {}
}

export class GetCentralStationProjectDataFailure implements Action {
    readonly type = ActionTypes.GetCentralStationProjectDataFailure;

    constructor(public error: DataServiceError<CentralStationProject[]>) {}
}

export class UpdateProject implements Action {
    readonly type = ActionTypes.UpdateProject;

    constructor(
        public payload: {
            projectData: Project;
            customer?: User;
            id: number;
            closeDialog?: EventEmitter<any>;
        }
    ) {}
}

export class UpdateProjectSuccess extends ProjectSuccessAction {
    readonly type = ActionTypes.UpdateProjectSuccess;
}

export class UpdateProjectFailure implements Action {
    readonly type = ActionTypes.UpdateProjectFailure;

    constructor(public error: DataServiceError<Project>) {}
}

export class UpdateProjectDealer implements Action {
    readonly type = ActionTypes.UpdateProjectDealer;

    constructor(
        public payload: {
            projectData: any;
            customer?: User;
            id: number;
            closeDialog?: EventEmitter<any>;
            logData?: any;
        }
    ) {}
}

export class UpdateProjectDealerSuccess implements Action {
    readonly type = ActionTypes.UpdateProjectDealerSuccess;
}

export class UpdateProjectDealerFailure implements Action {
    readonly type = ActionTypes.UpdateProjectDealerFailure;

    constructor(public error: DataServiceError<Project>) {}
}

export class UpdateProjectController implements Action {
    readonly type = ActionTypes.UpdateProjectController;

    constructor(
        public claresystem: ClareSystem,
        public project: Project,
        public securitysystem?: SecuritySystem,
        public closeDialog?: any
    ) {}
}

export class GoToProjects implements Action {
    readonly type = ActionTypes.GoToProjects;
}

export class ProcessProject extends ProjectAction {
    readonly type = ActionTypes.ProcessProject;
}

export class DeleteProject extends ProjectAction {
    readonly type = ActionTypes.DeleteProject;
}

export class DeleteProjectConfirmation extends ProjectAction {
    readonly type = ActionTypes.DeleteProjectConfirmation;
}

export class DeleteProjectConfirmationDismiss implements Action {
    readonly type = ActionTypes.DeleteProjectConfirmationDismiss;
}

export class DeleteProjectSuccess extends ProjectSuccessAction {
    readonly type = ActionTypes.DeleteProjectSuccess;
}

export class DeleteProjectFailure extends ProjectFailureAction {
    readonly type = ActionTypes.DeleteProjectFailure;
}

export class UpsertSecuritySystem implements Action {
    readonly type = ActionTypes.UpsertSecuritySystem;

    constructor(
        public payload: {
            securitysystem: SecuritySystem;
            project: Project;
            callbackEmitter?: EventEmitter<any>;
        }
    ) {}
}

export class ClearProjectState implements Action {
    readonly type = ActionTypes.ClearProjectState;
}

export class ClearProjectStatuses implements Action {
    readonly type = ActionTypes.ClearProjectStatuses;
}

export class UpdateProjectStatuses implements Action {
    readonly type = ActionTypes.UpdateProjectStatuses;
    constructor(public payload: { uuids: string[] }) {}
}

export class UpdateProjectStatusesSuccess implements Action {
    readonly type = ActionTypes.UpdateProjectStatusesSuccess;
    constructor(public result: string[]) {}
}

export class UpdateProjectStatusesFailure extends ProjectFailureAction {
    readonly type = ActionTypes.UpdateProjectStatusesFailure;
}

export class ActiveOrSuspendProject implements Action {
    readonly type = ActionTypes.ActiveOrSuspendProject;

    constructor(
        public payload: {
            doActivate: boolean;
            projectId: number;
            closeDialog?: EventEmitter<any>;
        }
    ) {}
}

export class ActiveOrSuspendProjectSuccess implements Action {
    readonly type = ActionTypes.ActiveOrSuspendProjectSuccess;

    constructor(public readonly projectId: number, public readonly isInactive: boolean) {}
}

export class ActiveOrSuspendProjectFailure implements Action {
    readonly type = ActionTypes.ActiveOrSuspendProjectFailure;

    constructor(public error: DataServiceError<Project>) {}
}
export class MoveOutSuccess implements Action {
    readonly type = ActionTypes.MoveOutSuccess;
}

export class GetActivePanelSummary implements Action {
    readonly type = ActionTypes.GetActivePanelSummary;
    constructor(public payload: { uuid: string }) {}
}

export class GetActivePanelSummarySuccess implements Action {
    readonly type = ActionTypes.GetActivePanelSummarySuccess;
    constructor(
        public payload: {
            summary: PanelSummary;
        }
    ) {}
}

export class GetActivePanelSummaryFailure implements Action {
    readonly type = ActionTypes.GetActivePanelSummaryFailure;
    constructor(public error: DataServiceError<string>) {}
}

export class ClearActivePanelSummary implements Action {
    readonly type = ActionTypes.ClearActivePanelSummary;
}

export type Actions =
    | ClearProjectStatuses
    | UpdateProjectStatuses
    | UpdateProjectStatusesSuccess
    | UpdateProjectStatusesFailure
    | CreateProject
    | CreateProjectNoCustomer
    | CreateProjectController
    | CreateProjectControllerFailure
    | CreateProjectSuccess
    | CreateProjectFailure
    | GetProject
    | GetProjectSuccess
    | GetProjectFailure
    | ClearActiveProject
    | ClearActiveProjectEntity
    | GetActiveProject
    | GetActiveProjectSuccess
    | GetActiveProjectFailure
    | GetActiveProjectEntity
    | GetActiveProjectEntitySuccess
    | GetActiveProjectEntityFailure
    | SetSelectedEntity
    | SetSelectedEntitySuccess
    | GetActiveProjectStatus
    | GetActiveProjectStatusSuccess
    | GetActiveProjectStatusFailure
    | GetProjects
    | GetProjectsSuccess
    | GetProjectsFailure
    | GetProjectsUUIDs
    | GetProjectsUUIDsSuccess
    | GetProjectsUUIDsFailure
    | GetProjectUsers
    | GetProjectUsersSuccess
    | GetProjectUsersFailure
    | ClearCentralStationProjectData
    | GetCentralStationProjectData
    | GetCentralStationProjectDataSuccess
    | GetCentralStationProjectDataFailure
    | UpdateProject
    | UpdateProjectSuccess
    | UpdateProjectFailure
    | UpdateProjectDealer
    | UpdateProjectDealerSuccess
    | UpdateProjectDealerFailure
    | GoToProjects
    | ProcessProject
    | UpdateProjectController
    | UpdateProjectControllerSuccess
    | CreateProjectUser
    | CreateProjectUserSuccess
    | CreateProjectUserFailure
    | UpdateProjectUser
    | UpdateProjectUserSuccess
    | UpdateProjectUserFailure
    | DeleteProjectUser
    | DeleteProjectUserConfirmation
    | DeleteProjectUserConfirmationDismiss
    | DeleteProjectUserSuccess
    | DeleteProjectUserFailure
    | DeleteProject
    | DeleteProjectConfirmation
    | DeleteProjectConfirmationDismiss
    | DeleteProjectSuccess
    | DeleteProjectFailure
    | UpsertSecuritySystem
    | ClearProjectState
    | ClearActiveProjectStatus
    | ActiveOrSuspendProject
    | ActiveOrSuspendProjectSuccess
    | ActiveOrSuspendProjectFailure
    | GetActiveProjectByUuid
    | ClearProjects
    | GetActivePanelSummary
    | GetActivePanelSummarySuccess
    | GetActivePanelSummaryFailure
    | ClearActivePanelSummary;
